<template>
  <div class="card-body">
    <div class="row">
      <div
        class="col-lg-3"
        :key="`totals-${index}`"
        v-for="(group, index) in rateGroups"
      >
        <group-total-widget
          :group="group"
          :recovery="recovery"
        ></group-total-widget>
      </div>
    </div>

    <totals :recovery="recovery" :payments="payments"></totals>

    <fieldset>
      <legend>Hire Vehicle Details</legend>
      <div class="row">
        <div class="col-lg-3">
          <div class="widget widget-primary">
            <div class="widget-label">Daily Rate</div>
            <div class="widget-value">
              {{ recovery?.hire?.hire_rate | currency('£', false) }}
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget widget-primary">
            <div class="widget-label">Commercial Daily Rate</div>
            <div class="widget-value">
              {{ recovery?.hire?.commercial_rate | currency('£', false) }}
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget widget-primary">
            <div class="widget-label">Client's Vehicle Group</div>
            <div class="widget-value">
              {{ clientVehicle?.group?.name || 'Not Provided' }}
            </div>
          </div>
        </div>

        <div class="col-lg-3">
          <div class="widget widget-primary">
            <div class="widget-label">Hire Vehicle Group</div>
            <div class="widget-value">
              {{ recovery?.hire?.abi_group?.name }}
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend class="clearfix">
        Payments
        <button
          class="btn btn-primary float-right"
          v-on:click.prevent="openAddPaymentModal"
        >
          Add Payment
        </button>
      </legend>

      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th>Payment Date</th>
            <th>Payment Amount (&pound;)</th>
            <th>Payment Type</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-bind:key="index"
            v-for="(payment, index) in payments"
            v-on:click="openEditPaymentModal(payment)"
          >
            <td v-text="formatDate(payment.date)"></td>
            <td v-text="formatAmount(payment.value)"></td>
            <td v-text="payment.method.label"></td>
          </tr>
        </tbody>
      </table>
    </fieldset>

    <fieldset>
      <legend class="clearfix">
        Overpayments
        <button
          class="btn btn-primary float-right"
          v-on:click.prevent="openAddOverpaymentModal"
        >
          Add Overpayment
        </button>
      </legend>

      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th>Overpayment Date</th>
            <th>Overpayment Amount (&pound;)</th>
            <th>Comment</th>
            <th>Date Returned</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-bind:key="index"
            v-for="(overpayment, index) in overpayments"
            v-on:click="openEditOverpaymentModal(overpayment)"
          >
            <td v-text="formatDate(overpayment.overpayment_date)"></td>
            <td v-text="formatAmount(overpayment.value)"></td>
            <td v-text="overpayment.comment"></td>
            <td v-text="formatDate(overpayment.return_date)"></td>
          </tr>
        </tbody>
      </table>
    </fieldset>

    <add-payment
      :incident="incident"
      :recovery="recovery"
      :show="modals.add"
      v-on:close="closeAddPaymentModal"
    ></add-payment>

    <edit-payment
      :payment="editPayment"
      :incident="incident"
      :recovery="recovery"
      :show="modals.edit"
      v-if="modals.edit"
      v-on:close="closeEditPaymentModal"
      v-on:deleted="deletePayment(editPayment)"
    ></edit-payment>

    <add-overpayment
      :incident="incident"
      :recovery="recovery"
      :show="modals.addOverpayment"
      v-on:close="closeAddOverpaymentModal"
    ></add-overpayment>

    <edit-overpayment
      :overpayment="editOverpayment"
      :incident="incident"
      :recovery="recovery"
      :show="modals.editOverpayment"
      v-if="modals.editOverpayment"
      v-on:close="closeEditOverpaymentModal"
    ></edit-overpayment>
  </div>
</template>
<script>
import AddPayment from './../Children/AddPayment.vue';
import EditPayment from './../Children/EditPayment.vue';
import AddOverpayment from './../Children/AddOverpayment.vue';
import EditOverpayment from './../Children/EditOverpayment.vue';
import GroupTotalWidget from '@/components/Modules/Recovery/Sections/Payments/GroupTotalWidget';
import Totals from '@/components/Modules/Recovery/Sections/Payments/Totals';

export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    recovery: {
      type: Object,
      required: true
    }
  },

  components: {
    'add-payment': AddPayment,
    'edit-payment': EditPayment,
    'add-overpayment': AddOverpayment,
    'edit-overpayment': EditOverpayment,
    GroupTotalWidget,
    Totals
  },

  computed: {
    rateGroups() {
      return this.$store.getters['RateGroups/all'];
    },

    clientVehicle() {
      return this.$store.getters['Incident/clientVehicle'];
    }
  },

  data() {
    return {
      editPayment: {},
      editOverpayment: {},
      payments: [],
      overpayments: [],
      modals: {
        add: false,
        edit: false,
        addOverpayment: false,
        editOverpayment: false
      }
    };
  },

  mounted() {
    this.getPayments();
    this.getOverpayments();
  },

  methods: {
    formatAmount(amount) {
      return this.penceToPounds(amount);
    },

    formatDate(value) {
      return window.DateManager.format(value);
    },

    openEditPaymentModal(payment) {
      this.editPayment = payment;
      this.modals.edit = true;
    },

    closeAddPaymentModal() {
      this.modals.add = false;
      this.getPayments();
    },

    closeEditPaymentModal(payment) {
      this.editPayment = {};
      this.modals.edit = false;
      this.getPayments();
    },

    openAddPaymentModal() {
      this.modals.add = true;
    },

    getPayments() {
      window.Ajax.get(`/debt-recovery/${this.incident}`)
        .then(response => {
          this.$store.commit('DebtRecovery/set', response.data);
        })
        .catch(error => {});

      window.Ajax.get(`/debt-recovery/${this.incident}/payments`)
        .then(response => {
          this.payments = response.data;
        })
        .catch(error => {});
    },

    openEditOverpaymentModal(overpayment) {
      this.editOverpayment = overpayment;
      this.modals.editOverpayment = true;
    },

    closeAddOverpaymentModal() {
      this.modals.addOverpayment = false;
      this.getOverpayments();
    },

    closeEditOverpaymentModal() {
      this.editOverpayment = {};
      this.modals.editOverpayment = false;
      this.getOverpayments();
    },

    openAddOverpaymentModal() {
      this.modals.addOverpayment = true;
    },

    getOverpayments() {
      window.Ajax.get(`/debt-recovery/${this.incident}/overpayments`)
        .then(response => {
          this.overpayments = response.data;
        })
        .catch(error => {});
    },

    groupTotal(group) {
      return 0;
    }
  }
};
</script>
